import { startCase, toLower } from "lodash";
import { DOMAIN, PERMISSION } from "@/hooks/useCapabilities";
import { NavLink } from "@/layouts/AppLayout/types";
import type { FlagRecord } from "@/hooks/useFeatureFlags";
import type { Capability } from "@/providers/AuthorizationProvider";
import { Path } from "@/router";

export const COMMISSION_TAB_ITEMS: { label: string; to: Path }[] = [
  { label: "Programs", to: "/billing/finance/commission/programs" },
  { label: "Partners", to: "/billing/finance/commission/partners" },
  { label: "Campaigns", to: "/billing/finance/commission/campaigns" },
  { label: "Enrollments", to: "/billing/finance/commission/enrollments" },
  { label: "Ingest", to: "/billing/finance/commission/ingest" },
  { label: "Funding", to: "/billing/finance/commission/funding" },
  { label: "Release", to: "/billing/finance/commission/release" }
];

export const COMMISSION_HOME_PATH: Path = "/billing/finance/commission/programs";

export const canViewCommissionPlatform = (capabilities: Capability): boolean =>
  capabilities.domains.includes(DOMAIN.BENEFIT_PROGRAMS) &&
  capabilities.permissions.includes(PERMISSION.viewGrpCommission);

export const canManageCommissionPlatform = (capabilities: Capability): boolean =>
  capabilities.domains.includes(DOMAIN.BENEFIT_PROGRAMS) &&
  capabilities.permissions.includes(PERMISSION.manageGrpCommission);

export const canShowCommissionPlatformChrome = (flags: FlagRecord, capabilities: Capability): boolean =>
  !!flags["commission-grp-platform"] && canViewCommissionPlatform(capabilities);

export const getCommissionNavLinks = (): NavLink<Path>[] => [
  {
    domain: DOMAIN.BENEFIT_PROGRAMS,
    label: "Commission Platform",
    link: { to: "/billing/finance/commission" },
    icon: "settings"
  },
  {
    domain: DOMAIN.BENEFIT_PROGRAMS,
    label: "All Finance",
    link: { to: "/billing/finance" },
    icon: "card_membership",
    trailingIcon: "navigate_next",
    dividerBefore: true,
    externalLink: true
  }
];

export function formatEnumLabel(value: string): string {
  return startCase(toLower(value));
}
